<template>
    <div
        class="cards-sidebar w-3/4 md:col-span-3 absolute top-16 left-0 xl:auto xl:block transition-transform z-50 xl:static xl:top-auto xl:right-auto xl:translate-x-0 xl:w-full"
        :class="{ '-translate-x-[105%]': !showFiltersMenu }"
    >
        <div>
            <div
                class="bg-white dark:bg-slate-800 shadow dark:shadow-slate-900/50 ring-1 ring-black/5 dark:ring-slate-700 md:rounded-lg mb-5"
            >
                <div
                    class="flex items-center justify-between px-4 pt-3 xl:hidden"
                >
                    <h2 class="text-lg font-medium text-gray-900 dark:text-slate-100">Filters</h2>
                    <button
                        type="button"
                        class="-mr-2 flex h-10 w-10 items-center justify-center p-2 text-gray-400 dark:text-slate-400 hover:text-gray-500 dark:hover:text-slate-200"
                        @click="toggleFiltersMenu"
                    >
                        <span class="sr-only">Close menu</span>
                        <svg
                            class="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>

                <div class="grid grid-cols-12 gap-4 px-5 py-5 mb-8">
                    <div class="col-span-12">
                        <h3 class="font-bold mb-1">Recommended Cards</h3>
                        <ul class="text-sm">
                            <li class="mb-1 text-orange">
                                <a
                                    href="#"
                                    @click.prevent="clearFilters"
                                    role="button"
                                    class="text-orange-500 hover:text-orange-400 p-0"
                                    id="hs-next-card-filters-view-all"
                                >
                                    View All
                                </a>
                            </li>
                            <li
                                v-for="(type, t) in types"
                                class="mb-2"
                                :key="'type-' + t"
                            >
                                <label
                                    class="mr-3"
                                    :class="{ disabled: !type.enabled }"
                                >
                                    <input
                                        type="checkbox"
                                        class="form-checkbox mr-1"
                                        v-model="type.checked"
                                        @change="
                                            toggleFilter(type.value, 'types')
                                        "
                                        :disabled="!type.enabled"
                                        :id="`hs-next-card-filter-type-${type.value}`"
                                    />
                                    {{ type.name }}
                                </label>
                            </li>
                        </ul>
                        <ul class="text-sm">
                            <li
                                v-for="(program, p) in programTypes"
                                class="mb-2"
                                :key="'program-' + p"
                            >
                                <label
                                    class="mr-3"
                                    :class="{
                                        disabled: !program.enabled,
                                    }"
                                >
                                    <input
                                        type="checkbox"
                                        v-model="program.checked"
                                        class="form-checkbox mr-1"
                                        @change="
                                            toggleFilter(
                                                program.type,
                                                'programs'
                                            )
                                        "
                                        :disabled="!program.enabled"
                                        :id="`hs-next-card-filter-program-${program.type}`"
                                    />
                                    {{ goodProgramName(program.type) }}
                                    Rewards
                                </label>
                            </li>
                        </ul>
                        <ul class="mb-5">
                            <li class="mb-1">
                                <label class="mb-2 mr-3 flex items-center">
                                    <input
                                        type="checkbox"
                                        name="bonus_rec"
                                        value="1"
                                        class="form-checkbox mr-2"
                                        v-model="localShowHidden"
                                        @change="setShowHidden(localShowHidden)"
                                        id="hs-next-card-filter-show-hidden"
                                    />
                                    <span
                                        class="font-medium text-sm text-gray-400 dark:text-slate-300 flex items-center"
                                    >
                                        Show Hidden Cards
                                        <span
                                            class="inline-block rounded-full text-gray-400 text-center relative annual-fee-label-trigger cursor-pointer -translate-y-[4px] xl:translate-y-0 ml-3"
                                        >
                                            <span
                                                class="annual-fee-label text-xs !-left-[200%] lg:!left-2/4"
                                            >
                                                View all cards, even ones that
                                                you don't currently qualify for.
                                            </span>
                                            <i
                                                class="fa-regular fa-circle-info"
                                            ></i>
                                        </span>
                                    </span>
                                </label>
                            </li>
                            <li
                                class="mb-1 relative"
                                :class="{
                                    'z-40 bg-white dark:bg-slate-800 p-1 px-2 rounded':
                                        showFive24FilterCallout,
                                }"
                            >
                                <!-- Mobile Modal -->
                                <ui-modal-mobile
                                    v-if="isMobile"
                                    :is-open="showFive24FilterCallout && !hide524Callout"
                                    @close="setFive24shownCookie"
                                    title="You're Under 5/24"
                                >
                                    <template #content>
                                        <div class="modal-body prose dark:prose-invert text-sm">
                                            <p class="mb-4">
                                                Since you're under 5/24, we
                                                automatically enabled this
                                                filter for you.
                                            </p>

                                            <p class="mb-4">
                                                With this filter enabled, you'll
                                                see which cards in My Next Card
                                                will add to your 5/24 count. For
                                                users newer to points and miles,
                                                we'd highly encourage leaving
                                                this filter turned on.
                                            </p>
                                            <p class="mb-4">
                                                To learn more about the 5/24
                                                rule and why we're making these
                                                recommendations, see this
                                                <a
                                                    href="https://10xtravel.com/chase-5-24-rule/"
                                                    target="_blank"
                                                    class="text-orange-500 hover:text-orange-400 no-underline"
                                                    id="hs-next-card-learn-5-24-rule"
                                                >
                                                    overview of the Chase 5/24
                                                    rule.
                                                </a>
                                            </p>
                                        </div>
                                    </template>
                                    <template #footer>
                                        <button
                                            type="button"
                                            class="btn btn-primary w-full"
                                            @click="setFive24shownCookie"
                                        >
                                            Got it
                                        </button>
                                    </template>
                                </ui-modal-mobile>

                                <!-- Desktop Callout -->
                                <div
                                    v-if="!isMobile"
                                    class="-top-16 left-0 xl:left-auto xl:-right-80 text-white border border-slate-200 dark:border-slate-700 rounded-md z-60"
                                    :class="{
                                        absolute:
                                            showFive24FilterCallout &&
                                            !hide524Callout,
                                        hide: !showFive24FilterCallout,
                                    }"
                                    v-show="
                                        showFive24FilterCallout &&
                                        !hide524Callout
                                    "
                                    v-cloak
                                >
                                    <div
                                        class="inner bg-gray-50 dark:bg-slate-700 shadow border border-gray-200 dark:border-slate-600 overflow-hidden w-full max-w-sm p-6 rounded-md"
                                        style="
                                            -webkit-transform: translate3d(
                                                0,
                                                0,
                                                0
                                            );
                                        "
                                    >
                                        <div
                                            class="absolute top-0 right-0 hidden pt-4 pr-6 sm:block"
                                        >
                                            <button
                                                type="button"
                                                class="btn-base btn-hollow rounded-md text-gray-400 dark:text-slate-400 hover:text-gray-500 dark:hover:text-slate-200 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-offset-2 dark:focus:ring-offset-slate-700"
                                                @click="setFive24shownCookie"
                                                id="hs-next-card-close-5-24-popup"
                                            >
                                                <span class="sr-only">
                                                    Close
                                                </span>
                                                <i
                                                    class="fal fa-times fa-lg"
                                                ></i>
                                            </button>
                                        </div>
                                        <div
                                            class="modal-body items-start prose dark:prose-invert text-sm"
                                        >
                                            <h3
                                                class="text-xl md:text-2xl text-gray-800 dark:text-slate-100 font-bold mb-5 text-left"
                                            >
                                                You're Under 5/24
                                            </h3>
                                            <p class="mb-5">
                                                Since you’re under 5/24, we
                                                automatically enabled this
                                                filter for you.
                                            </p>

                                            <p>
                                                With this filter enabled, you’ll
                                                see which cards in My Next Card
                                                will add to your 5/24 count. For
                                                users newer to points and miles,
                                                we’d highly encourage leaving
                                                this filter turned on.
                                            </p>
                                            <p class="mb-5">
                                                To learn more about the 5/24
                                                rule and why we’re making these
                                                recommendations, see this
                                                <a
                                                    href="https://10xtravel.com/chase-5-24-rule/"
                                                    target="_blank"
                                                    class="btn-base btn-hollow text-orange-500 hover:text-orange-400 no-underline p-0"
                                                    id="hs-next-card-learn-5-24-rule"
                                                >
                                                    overview of the Chase 5/24
                                                    rule.
                                                </a>
                                            </p>

                                            <button
                                                type="button"
                                                class="btn btn-primary !block ml-auto"
                                                @click="setFive24shownCookie"
                                            >
                                                Got it 👍🏻
                                            </button>
                                            <!-- -->
                                        </div>
                                    </div>
                                </div>
                                <label class="mr-3 flex items-center">
                                    <input
                                        type="checkbox"
                                        name="five_24"
                                        value="1"
                                        class="form-checkbox mr-2"
                                        v-model="localShow524"
                                    />
                                    <span
                                        class="font-medium text-sm text-gray-400 dark:text-slate-300 flex items-center"
                                    >
                                        Under 5/24

                                        <span
                                            class="inline-block rounded-full text-gray-400 text-center relative annual-fee-label-trigger cursor-pointer -translate-y-[4px] xl:translate-y-0 ml-3"
                                        >
                                            <span
                                                class="annual-fee-label text-xs !-left-[200%] lg:!left-2/4"
                                            >
                                                With this filter enabled, you’ll
                                                see which cards in My Next Card
                                                will add to your 5/24 count. For
                                                users newer to points and miles,
                                                we’d highly encourage leaving
                                                this filter turned on.
                                            </span>
                                            <i
                                                class="fa-regular fa-circle-info"
                                            ></i>
                                        </span>
                                    </span>
                                </label>
                            </li>
                        </ul>
                        <button
                            type="button"
                            class="flex w-full items-center justify-between p-2 hover:text-gray-700 dark:hover:text-slate-100 p-0 py-3 lg:hidden"
                            @click="showSpends = !showSpends"
                            aria-controls="filter-section-2"
                            :aria-expanded="showSpends"
                        >
                            <h3 class="font-bold mb-1">Spend Required</h3>
                            <span class="ml-6 flex h-7 items-center">
                                <svg
                                    class="h-5 w-5 transform"
                                    :class="{
                                        'rotate-0': !showSpends,
                                        '-rotate-180': showSpends,
                                    }"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </span>
                        </button>
                        <h3 class="font-bold mb-1 hidden lg:block">
                            Spend Required
                        </h3>
                        <ul
                            class="mb-5 text-sm lg:block"
                            :class="{ hidden: !showSpends }"
                        >
                            <li
                                v-for="(spend, s) in spends"
                                class="mb-3"
                                :key="'spend-' + s"
                            >
                                <label class="mb-2 mr-3">
                                    <input
                                        type="checkbox"
                                        v-model="spend.checked"
                                        class="form-checkbox mr-1"
                                        @change="
                                            toggleFilter(spend.value, 'spends')
                                        "
                                        :id="'hs-next-card-spend-filter-' + spend.value"
                                    />
                                    ${{ $filters.formatThousand(spend.value) }}
                                    <span v-if="spend.value !== 0">
                                        and below
                                    </span>
                                </label>
                            </li>
                        </ul>
                        <button
                            type="button"
                            class="flex w-full items-center justify-between p-2 hover:text-gray-700 dark:hover:text-slate-100 p-0 py-3 lg:hidden outline-none"
                            @click="showBanks = !showBanks"
                            aria-controls="filter-section-2"
                            :aria-expanded="showBanks"
                        >
                            <h3 class="font-bold mb-1">Issuing Banks</h3>
                            <span class="ml-6 flex h-7 items-center">
                                <svg
                                    class="h-5 w-5 transform"
                                    :class="{
                                        'rotate-0': !showBanks,
                                        '-rotate-180': showBanks,
                                    }"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </span>
                        </button>
                        <h3 class="font-bold mb-1 hidden lg:block">
                            Issuing Banks
                        </h3>
                        <ul
                            class="mb-3 text-sm lg:block"
                            :class="{ hidden: !showBanks }"
                        >
                            <li
                                v-for="(bank, b) in banks"
                                class="mb-2"
                                :key="'bank-' + b"
                            >
                                <label
                                    class="mr-3"
                                    :class="{ disabled: !bank.enabled }"
                                >
                                    <input
                                        type="checkbox"
                                        v-model="bank.checked"
                                        class="form-checkbox mr-1"
                                        @change="
                                            toggleFilter(bank.code, 'banks')
                                        "
                                        :disabled="!bank.enabled"
                                        :id="'hs-next-card-bank-filter-' + bank.code.toLowerCase()"
                                    />
                                    {{ bank.name }}
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="fixed bg-gray-200/90 dark:bg-slate-900/80 inset-0 z-30"
            v-if="showFive24FilterCallout"
        ></div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useNextCardStore } from '@/store/nextcard';
import UiModalMobile from '@/components/ui/modal/ui-modal-mobile.vue';
import { useIsMobile } from '@/composables/useIsMobile';

export default {
    components: {
        UiModalMobile,
    },
    setup() {
        const { isMobile } = useIsMobile();
        return { isMobile };
    },
    data: () => ({
        showSpends: false,
        showBanks: false,
        localShowHidden: false,
    }),
    computed: {
        ...mapState(useNextCardStore, [
            'loading',
            'filters',
            'types',
            'programTypes',
            'banks',
            'spends',
            'pageCount',
            'showHidden',
            'show524',
            'showFiltersMenu',
            'fiveTwentyFourCount',
            'showFive24FilterCallout',
            'hide524Callout',
        ]),
        localShow524: {
            get() {
                return this.show524;
            },
            set(val) {
                this.setShow524(val);
            },
        },
    },
    watch: {
        // Removed automatic toggle of show524 based on count
        // Users should manually control the 5/24 pill visibility
    },
    methods: {
        ...mapActions(useNextCardStore, [
            'toggleFilter',
            'toggleFiltersMenu',
            'clearFilters',
            'goodProgramName',
            'setShowHidden',
            'setShow524',
            'setFive24shownCookie',
        ]),
    },
};
</script>
<style lang="scss" scoped>
.annual-fee-label-trigger {
    &:hover {
        .annual-fee-label {
            display: block;
        }
    }
}
.annual-fee-label {
    display: none;
    width: 200px;
    padding: 6px 12px;
    color: #fff;
    background-color: #1c293d;
    border-radius: 4px;
    position: absolute;
    bottom: 110%;
    left: 50%;
    margin-left: -100px;
}
</style>
